import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled, Theme } from '@mui/material/styles';
import { Box, Link, Typography } from '@mui/material';
// hooks
import useAuth from '../../../hooks/useAuth';
// routes
import { PATH_MAIN } from '../../../routes/paths';
// components
import MyAvatar from '../../../components/MyAvatar';
import { UserRole } from '../../../enums/shared.enums';
import { FULL_ROLE_TITLES } from '../../../constants/common.constants';
import useLocales from '../../../hooks/useLocales';
import { formatStringToKey } from '../../../utils/locales';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2, 2.5),
    borderRadius: Number(theme.shape.borderRadius) * 1.5,
    backgroundColor: theme.palette.grey[500_12],
    transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.shorter,
    }),
}));

// ----------------------------------------------------------------------

type Props = {
    isCollapse: boolean | undefined;
};

export default function NavbarAccount({ isCollapse }: Props) {
    const { user, isClient } = useAuth();

    const { translate } = useLocales();

    const fullRoleTitle = FULL_ROLE_TITLES[user?.role?.name as UserRole];

    return (
        <Link underline="none" color="inherit" component={RouterLink} to={PATH_MAIN.account}>
            <RootStyle
                sx={{
                    ...(isCollapse && {
                        bgcolor: 'transparent',
                    }),
                }}
            >
                <MyAvatar />

                <Box
                    sx={{
                        ml: 2,
                        transition: (theme: Theme) =>
                            theme.transitions.create('width', {
                                duration: theme.transitions.duration.shorter,
                            }),
                        ...(isCollapse && {
                            ml: 0,
                            width: 0,
                        }),
                        overflowX: 'hidden',
                    }}
                >
                    <Typography variant="subtitle2">{user?.name}</Typography>
                    {!isClient && (
                        <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
                            {fullRoleTitle
                                ? translate(
                                      'constants.common.roleTitles.' +
                                          formatStringToKey(fullRoleTitle),
                                      { defaultValue: fullRoleTitle }
                                  )
                                : user?.role?.name}
                        </Typography>
                    )}
                </Box>
            </RootStyle>
        </Link>
    );
}
